import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, primeCsrf } from './api';
import type { SessionData } from '@/types/api';

const KEY = ['me', 'sessions'] as const;

export function useMySessions() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<SessionData[]> => {
      const { data } = await api.get<SessionData[]>('/v1/me/sessions');
      return data;
    },
  });
}

export function useRevokeSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (sessionId: string): Promise<void> => {
      await primeCsrf();
      await api.delete(`/v1/me/sessions/${sessionId}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useRevokeOtherSessions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<void> => {
      await primeCsrf();
      await api.delete('/v1/me/sessions/others');
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
